<div class="mobile-page-shell" [class.mobile-page-shell--no-nav]="hideBottomNav">
  <ng-content></ng-content>
</div>
